import React from 'react';
import { string, bool, func } from 'prop-types';
import clsx from 'clsx';
import NewWindowIcon from 'assets/images/icons/new-window-icon.svg';
import FacebookIcon from 'assets/images/icons/facebook.svg';
import LinkedInIcon from 'assets/images/icons/linkedin.svg';
import MailIcon from 'assets/images/icons/mail.svg';
import CopyUrl from 'assets/images/icons/copy-url.svg';
import StartArrow from 'assets/images/icons/start-arrow.svg';
import styles from './StandardButton.module.scss';

const icons = {
  newWindow: <NewWindowIcon />,
  facebook: <FacebookIcon />,
  linkedin: <LinkedInIcon />,
  mail: <MailIcon />,
  copyUrl: <CopyUrl />,
  startArrow: <StartArrow />,
};

const StandardButton = ({
  icon,
  url,
  target,
  label,
  className,
  isPrimary,
  isYellow,
  isDark,
  primaryFontColor,
  iconAlignLeft,
  onClick,
}) => {
  const classNames = clsx(styles.button, className, {
    [styles.isPrimary]: isPrimary,
    [styles.isDark]: isDark,
    [styles.isYellow]: isYellow,
    [styles.primaryFontColor]: primaryFontColor,
    [styles.iconAlignLeft]: iconAlignLeft,
  });

  return (
    <>
      {!onClick && (
        <a target={target} href={url} className={classNames}>
          {iconAlignLeft && (
            <span className={styles.iconLeft}>{icons[icon]}</span>
          )}
          {label && <span className={styles.label}>{label}</span>}
          {!iconAlignLeft && (
            <span className={styles.iconRight}>{icons[icon]}</span>
          )}
        </a>
      )}
      {onClick && (
        <button type="button" onClick={onClick} className={classNames}>
          {iconAlignLeft && (
            <span className={styles.iconLeft}>{icons[icon]}</span>
          )}
          {label && <span className={styles.label}>{label}</span>}
          {!iconAlignLeft && (
            <span className={styles.iconRight}>{icons[icon]}</span>
          )}
        </button>
      )}
    </>
  );
};

StandardButton.propTypes = {
  icon: string,
  url: string,
  target: string,
  label: string,
  className: string,
  isPrimary: bool,
  isYellow: bool,
  isDark: bool,
  iconAlignLeft: bool,
  primaryFontColor: bool,
  onClick: func,
};

StandardButton.defaultProps = {
  icon: null,
  url: null,
  target: '_blank',
  label: null,
  isPrimary: false,
  isYellow: false,
  isDark: false,
  iconAlignLeft: false,
  primaryFontColor: false,
  className: null,
  onClick: null,
};

export default StandardButton;
